// extracted by mini-css-extract-plugin
export default {"openOrders__list":"F7Kbu","openOrders__disabled":"bF8Oe"};